import { Button, Grid, Typography } from '@mui/material'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

export const NotFoundBoundary = () => {
  const { t } = useTranslation('common')
  const { push, reload } = useRouter()

  const handleHomeButtonClicked = async () => {
    await push('/')
    reload()
  }

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ flex: 1, width: '100%', minHeight: '100vh', p: 2 }}
    >
      <Grid
        container
        direction="column"
        sx={(theme) => ({
          backgroundColor: theme.palette.bg.surface.elevated,
          borderRadius: '8px',
          boxShadow: theme.customShadows.sm,
          alignItems: 'center',
          textAlign: 'center',
          padding: '40px',
          width: '100%',
          maxWidth: '480px',
        })}
      >
        <Image src="/app/assets/error-image.svg" alt="error" height={160} width={280} />
        <Grid>
          <Typography sx={{ mt: '30px', color: 'text.default', fontSize: '25px', fontWeight: 600 }}>
            {t('not-found-boundary.title')}
          </Typography>
        </Grid>
        <Grid>
          <Typography sx={{ mt: '15px', color: 'text.muted', fontSize: '14px', fontWeight: 400 }}>
            {t('not-found-boundary.subtext1')}
          </Typography>
        </Grid>
        <Grid>
          <Typography sx={{ mt: '10px', color: 'text.muted', fontSize: '14px', fontWeight: 400 }}>
            {t('not-found-boundary.subtext2')}
          </Typography>
        </Grid>
        <Button sx={{ mt: '20px' }} variant="contained" color="secondary" onClick={() => handleHomeButtonClicked()}>
          {t('error-boundary.return-home-button')}
        </Button>
      </Grid>
    </Grid>
  )
}
